/**
 * Remove any scripts from html
 *
 * @param {string} html
 * @returns {string}
 */
export default function sanitizeHtml(html) {
  // Create HTML element to manipulate
  const div = document.createElement('div');

  div.innerHTML = html;

  // Remove scripts
  const scripts = div.getElementsByTagName('script');
  let i = scripts.length;
  while (i > 0) {
    scripts[i - 1].parentNode.removeChild(scripts[i - 1]);
    i -= 1;
  }

  return div.innerHTML;
}
